import IssueCollector from './issue-collector';

export default IssueCollector;
